export function getBrowserLocalStorage<T extends Storage>(): T | null {
  return typeof window !== 'undefined' && window.localStorage ? window.localStorage as T : null;
}

export function useLocalStorage() {
  const localStorage = getBrowserLocalStorage<Storage>();

  function setItem(key: string, value: string): void {
    localStorage?.setItem(key, value);
  }

  function getItem(key: string): string | null {
    return localStorage ? localStorage.getItem(key) : null;
  }

  function removeItem(key: string): void {
    localStorage?.removeItem(key);
  }

  function clear(): void {
    localStorage?.clear();
  }

  return { setItem, getItem, removeItem, clear };
}
